import { render, staticRenderFns } from "./FaturamentoListFiltroModalItemInputTransportadora.vue?vue&type=template&id=c7215e4e"
import script from "./FaturamentoListFiltroModalItemInputTransportadora.vue?vue&type=script&lang=js"
export * from "./FaturamentoListFiltroModalItemInputTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports